export default __webpack_public_path__ + "static/media/SpiritWT-NewDigital.8ed4c7d0.png";